import "core-js/modules/es6.object.assign.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React from 'react';
import classnames from 'classnames';
import baseStyles, { mergeStyles } from '@nerdwallet/base-styles/react';

/**
 * Converts a prop value (either a literal, like `4`, or a responsive value,
 * like `{ mobile: 2, desktop: 4}`) to a value that can be passed to
 * `classes(...)` to resolve to classnames.
 *
 * The conversion is based on the convention that `base-styles` tokens are
 * generally in the form `NAME-VALUE`, e.g. `margin-all-3`, where VALUE is
 * the prop value. For desktop values, `NAME-VALUE--wide` is used instead.
 *
 * For tokens that don't follow this pattern, like `flex-wrap` (which has the
 * tokens `flex-wrap` and `flex-wrap-nowrap`), you can provide a custom
 * `resolvePropValue` function.
 */
function resolveResponsiveProp(props, name) {
  var resolvePropValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (value) {
    return "".concat(name, "-").concat(value);
  };

  if (!props) {
    return undefined;
  }

  if (typeof props === 'string' || typeof props === 'number') {
    // Simple case - only need a single value
    return resolvePropValue(props);
  }

  if (_typeof(props) === 'object') {
    var mobile = props.mobile,
        desktop = props.desktop;
    return [mobile && resolvePropValue(mobile), desktop && "".concat(resolvePropValue(desktop), "--wide")].filter(Boolean);
  }

  throw new Error("Invalid responsive props: ".concat(JSON.stringify(props)));
}

export var BoxImpl = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      alignSelf = _ref.alignSelf,
      backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      border = _ref.border,
      borderColor = _ref.borderColor,
      borderTop = _ref.borderTop,
      borderBottom = _ref.borderBottom,
      borderLeft = _ref.borderLeft,
      borderRight = _ref.borderRight,
      children = _ref.children,
      className = _ref.className,
      Component = _ref.component,
      display = _ref.display,
      flexWrap = _ref.flexWrap,
      justifyContent = _ref.justifyContent,
      margin = _ref.margin,
      marginX = _ref.marginX,
      marginY = _ref.marginY,
      marginTop = _ref.marginTop,
      marginBottom = _ref.marginBottom,
      marginLeft = _ref.marginLeft,
      marginRight = _ref.marginRight,
      maxWidth = _ref.maxWidth,
      opacity = _ref.opacity,
      padding = _ref.padding,
      paddingX = _ref.paddingX,
      paddingY = _ref.paddingY,
      paddingTop = _ref.paddingTop,
      paddingBottom = _ref.paddingBottom,
      paddingLeft = _ref.paddingLeft,
      paddingRight = _ref.paddingRight,
      position = _ref.position,
      shadow = _ref.shadow,
      style = _ref.style,
      userSelect = _ref.userSelect,
      width = _ref.width,
      restProps = _objectWithoutProperties(_ref, ["alignContent", "alignItems", "alignSelf", "backgroundColor", "borderRadius", "border", "borderColor", "borderTop", "borderBottom", "borderLeft", "borderRight", "children", "className", "component", "display", "flexWrap", "justifyContent", "margin", "marginX", "marginY", "marginTop", "marginBottom", "marginLeft", "marginRight", "maxWidth", "opacity", "padding", "paddingX", "paddingY", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "position", "shadow", "style", "userSelect", "width"]);

  var resolvedMarginTop = marginTop || marginY || margin;
  var resolvedMarginBottom = marginBottom || marginY || margin;
  var resolvedMarginLeft = marginLeft || marginX || margin;
  var resolvedMarginRight = marginRight || marginX || margin;
  var resolvedPaddingTop = paddingTop || paddingY || padding;
  var resolvedPaddingBottom = paddingBottom || paddingY || padding;
  var resolvedPaddingLeft = paddingLeft || paddingX || padding;
  var resolvedPaddingRight = paddingRight || paddingX || padding;
  var resolvedBorderTop = borderTop || border;
  var resolvedBorderBottom = borderBottom || border;
  var resolvedBorderLeft = borderLeft || border;
  var resolvedBorderRight = borderRight || border;
  return /*#__PURE__*/React.createElement(Component, _extends({}, restProps, mergeStyles(baseStyles(resolveResponsiveProp(alignContent, 'align-content'), resolveResponsiveProp(alignItems, 'align-items'), resolveResponsiveProp(alignSelf, 'align-self'), resolveResponsiveProp(backgroundColor, 'background'), resolveResponsiveProp(borderRadius, 'border-radius'), resolveResponsiveProp(borderColor, 'border'), resolveResponsiveProp(resolvedBorderTop, 'border-top'), resolveResponsiveProp(resolvedBorderBottom, 'border-bottom'), resolveResponsiveProp(resolvedBorderLeft, 'border-left'), resolveResponsiveProp(resolvedBorderRight, 'border-right'), resolveResponsiveProp(display, 'display'), resolveResponsiveProp(flexWrap, 'flex-wrap', function (token) {
    if (token === 'wrap') {
      return 'flex-wrap';
    }

    return 'flex-nowrap';
  }), resolveResponsiveProp(justifyContent, 'justify-content'), resolveResponsiveProp(resolvedMarginTop, 'margin-top'), resolveResponsiveProp(resolvedMarginBottom, 'margin-bottom'), resolveResponsiveProp(resolvedMarginLeft, 'margin-left'), resolveResponsiveProp(resolvedMarginRight, 'margin-right'), resolveResponsiveProp(maxWidth, 'max-width'), resolveResponsiveProp(opacity, 'opacity'), resolveResponsiveProp(resolvedPaddingTop, 'padding-top'), resolveResponsiveProp(resolvedPaddingBottom, 'padding-bottom'), resolveResponsiveProp(resolvedPaddingLeft, 'padding-left'), resolveResponsiveProp(resolvedPaddingRight, 'padding-right'), resolveResponsiveProp(position, 'position'), resolveResponsiveProp(shadow, 'shadow'), resolveResponsiveProp(userSelect, 'user-select'), resolveResponsiveProp(width, 'width')), {
    className: classnames(className),
    style: style
  }), {
    ref: ref
  }), children);
});